export const FairValueTooltip = () => {
  return (
    <div className="grid grid-cols-[220px] grid-rows-[auto_auto] gap-4">
      <div className="text-tiny">
        Current intrinsic value of a company based on an estimate of its
        potential future profits.{' '}
      </div>
      <div className="text-tiny">
        Fair value can be your own guidance of a safe price to buy the stock.
        Analyst price targets and our quantitative fair value are available to
        help with your estimate.
      </div>
    </div>
  );
};
